import React from "react";

export const PaymentList = ({payments, sitePrefix}) => (
  <>
    <div className="text-info">
      {
        sitePrefix !== undefined &&
        <p>
          <small className="text-muted" dangerouslySetInnerHTML={{
            __html: window.trans('front.order.checkout.shipping_step.index.rgpd_text', {
              '{{ prefix }}': sitePrefix
            })
          }}/>
        </p>
      }
      <p id="payment-reinsurance">
        <strong>{window.trans('front.order.checkout.shipping_step.index.payment_reinsurance')}</strong>
      </p>
    </div>
    <div id="payment-means">
      <ul>
        {payments !== undefined && payments.map((payment, index) => {
          return <li key={index}>
            {payment.img_path.length > 0 ? (
              <img src={payment.img_path} alt={payment.label}/>
            ) : (
              <p className="text-muted">payment.label</p>
            )}
            {payment.code && ['check', 'transfer'].includes(payment.code) &&
            <span dangerouslySetInnerHTML={{
              __html: window.trans(`front.order.checkout._block._payment_means.${payment.code}`)
            }}/>
            }
          </li>
        })}
      </ul>
    </div>
  </>
);

